import { Avatar } from '@latitude/avatar';
import { Button } from '@latitude/button';
import { CardListItem, type CardListItemProps } from '@latitude/card-list-item';
import { Text } from '@latitude/text';
import { PORTO_HELP_EMAIL, PORTO_ONBOARDING_SCHEDULE_URL } from '../../../constants';
type Step = Pick<CardListItemProps, 'title' | 'subtitle' | 'trailing'>;
const STEPS: Step[] = [{
  title: 'Schedule onboarding call',
  subtitle: 'with the Porto team',
  trailing: <a href={PORTO_ONBOARDING_SCHEDULE_URL} target="_blank" rel="noopener noreferrer" className="hidden sm:block">
        <Button size="small">Schedule now</Button>
      </a>
}, {
  title: 'Attend onboarding call',
  subtitle: 'to activate your account and get an overview of Porto'
}, {
  title: 'Account setup complete',
  subtitle: 'Your Porto account is activated and ready to use'
}];
export const NextSteps = () => <div className="flex flex-col gap-4" data-sentry-component="NextSteps" data-sentry-source-file="index.tsx">
    <Text variant="bodyBold" data-sentry-element="Text" data-sentry-source-file="index.tsx">Next steps</Text>
    {STEPS.map((step, index) => <CardListItem key={`next-step-${index + 1}`} leading={<Avatar type="letter" text={`${index + 1}`} />} className="hover:!bg-color-comp-card-list-container-enabled !cursor-default" {...step} />)}
    <Text variant="bodyRegular" color="muted" data-sentry-element="Text" data-sentry-source-file="index.tsx">
      Questions? Reach out to us at{' '}
      <Text asChild variant="link" color="muted" className="hover:text-color-ref-text-strong" data-sentry-element="Text" data-sentry-source-file="index.tsx">
        <a href={`mailto:${PORTO_HELP_EMAIL}`} target="_blank" rel="noopener noreferrer">
          {PORTO_HELP_EMAIL}
        </a>
      </Text>
    </Text>
  </div>;